import { createContext, useContext, useState, useCallback } from 'react';

const DownloadHistoryContext = createContext();

export function DownloadHistoryProvider({ children }) {
  const [history, setHistory] = useState([]);

  const addEntry = useCallback((entry) => {
    setHistory((prev) => [
      {
        id: Date.now() + Math.random(),
        timestamp: new Date().toISOString(),
        ...entry,
      },
      ...prev,
    ].slice(0, 50)); // keep last 50
  }, []);

  const clearHistory = useCallback(() => setHistory([]), []);

  return (
    <DownloadHistoryContext.Provider value={{ history, addEntry, clearHistory }}>
      {children}
    </DownloadHistoryContext.Provider>
  );
}

export function useDownloadHistory() {
  return useContext(DownloadHistoryContext);
}
